export default __webpack_public_path__ + "static/media/ic_down_caret_sm.c4a4d411.svg";